import { render } from "./ClientsBlock.vue?vue&type=template&id=3104931f&scoped=true"
import script from "./ClientsBlock.vue?vue&type=script&lang=js"
export * from "./ClientsBlock.vue?vue&type=script&lang=js"

import "./ClientsBlock.vue?vue&type=style&index=0&id=3104931f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3104931f"]])

export default __exports__